angular.module('aprima-legacy-common').factory('LogOffService',
    ['AprimaAnalytics', 'Bridge', 'LocalStorageRepository', '$q',
        function (AprimaAnalytics, Bridge, LocalStorageRepository, $q) {
            'use strict';

            return {
                logoff: logoff,
            };

            function logoff() {
                LocalStorageRepository.removeJsonWebToken();
                LocalStorageRepository.removeUserID();
                AprimaAnalytics.sendEvent('user', 'click', 'logoff', 0);

                Bridge.logoff('logoff');
                
                return $q.when();
            }
        }]);
